export const LOGIN_ERR_MSG = [
  "请先登录",
  "Require login",
  "user.login.required",
  "登录失效,请退出重新登陆!",
  "没有登录",
  "登入已失效，请重新登入",
  "Unauthorized"
];

export const MSG_KEY = ["errMessage", "msg", "message"];
